import React from "react";

// components
import FilterChips from "../../../components/FilterChips";
import { Filter } from "../../../components/FilterChips/FilterChips";
import { WORKFLOW_STATUS_OPTIONS, WorkflowsFilters } from "./WorkflowsFilterPanel";

const convertFiltersToReadableList = (filters: Partial<WorkflowsFilters>): Filter[] => {
	const readableList: Filter[] = [];

	if (filters.workflowName) {
		readableList.push({
			id: "workflowName",
			type: "string",
			label: "Workflow",
			value: filters.workflowName,
		});
	}

	if (filters.subject) {
		readableList.push({
			id: "subject",
			type: "single-employee",
			label: "Subject",
			value: { id: filters.subject.id, name: filters.subject.name },
		});
	}

	if (filters.status && filters.status !== "any") {
		readableList.push({
			id: "status",
			type: "string",
			label: "Status",
			value: WORKFLOW_STATUS_OPTIONS.find((option) => option.value === filters.status)?.label ?? filters.status,
		});
	}

	if (filters.overdueOnly && filters.overdueOnly.length > 0) {
		readableList.push({
			id: "overdueOnly",
			type: "customRender",
			label: "",
			value: <span>Only workflows with overdue to-dos</span>,
		});
	}

	if (filters.unassignedOnly && filters.unassignedOnly.length > 0) {
		readableList.push({
			id: "unassignedOnly",
			type: "customRender",
			label: "",
			value: <span>Only workflows with unassigned to-dos</span>,
		});
	}

	return readableList;
};

type ReadableWorkflowsFilterChipsProps = {
	filters: Partial<WorkflowsFilters>;
	setFilters: (newFilters: Partial<WorkflowsFilters>) => void;
};

const ReadableWorkflowsFilterChips = ({ filters, setFilters }: ReadableWorkflowsFilterChipsProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			{/* each chip has a built-in 2px vertical margin, so a 4px row gap yields 8px of visual vertical
			    spacing; the label's built-in margin is zeroed so the gap alone spaces it from the first chip */}
			<FilterChips
				className="flex flex-wrap items-center gap-x-2 gap-y-1 [&>[data-testid=mainLabel]]:!mr-0"
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					const currentFilters = { ...filters };
					delete currentFilters[id];

					setFilters({ ...currentFilters });
				}}
			/>
		</div>
	);
};

export default ReadableWorkflowsFilterChips;
